import { render } from "./AdminDefault.vue?vue&type=template&id=01cfa560"
import script from "./AdminDefault.vue?vue&type=script&lang=js"
export * from "./AdminDefault.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__